<h2 class="timetable-panel__title font-heading-4 font-title-medium nordic-blue-900-text text-icon-primary ms-clear-t">
  {{ 'timetable.panel.title' | finLocalization }}
</h2>

<fcom-tabs>
  <fcom-tab [title]="'timetable.panel.departure' | finLocalization">
    <fin-timetable-schedule
      [bounds]="departureBounds()"
      [loading]="departureLoading()"
      [originCode]="departureOriginCode()"
      [destinationCode]="departureDestinationCode()"
      [selectDateKey]="'timetable.flightList.selectDepartureDate'"
    />
  </fcom-tab>

  @if (showReturnTab()) {
    <fcom-tab [title]="'timetable.panel.return' | finLocalization">
      <fin-timetable-schedule
        [bounds]="returnBounds()"
        [loading]="returnLoading()"
        [originCode]="returnOriginCode()"
        [destinationCode]="returnDestinationCode()"
        [selectDateKey]="'timetable.flightList.selectReturnDate'"
      />
    </fcom-tab>
  }
</fcom-tabs>
